import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiRequestService } from '@core/services/api-request.service';
import { SessionStorageService } from '@core/services/session-storage.service';
import { TosterService } from '@core/services/toster.service';
import { UserService } from '@core/auth/user/user.service';
import { AppData } from '@core/services/app-data.service';
import { config } from '@core/services/request-url.service';
import { HttpApiService } from '@core/auth/http-api.service';
import { PermissionService } from '@core/auth/permission/permission.service';
import { WalletStore } from '@core/stores/wallet.store';
import { DashboardService } from '@page/dashboard/helper/dashboard-service';

@Injectable({ providedIn: 'root' })
export class AuthService {

    constructor(
        private _HttpApiService: HttpApiService,
        private apiRequest: ApiRequestService,
        private route: Router,
        private storage: SessionStorageService,
        private toater: TosterService,
        private _UserService: UserService,
        private _PermissionService: PermissionService,
        private _NgbModal: NgbModal,
        private _WalletStore: WalletStore,
        private _DashboardService: DashboardService,
    ) { }

    login(payloadData: any) {
        return this._HttpApiService.post(config.auth.login.url, payloadData);
    }

    // verifyOtp(payload: any) {
    //     return this.apiRequest.postdata(payload, config.auth.verifyOtp);
    // }

    changePassword(payload: any) {
        return this.apiRequest.postdata(payload, config.auth.changePassword);
    }

    forgetPasswordSendOtp(payload: any) {
        return this.apiRequest.postdata(payload, config.auth.forgetPasswordSendOtp);
    }

    // forgetPasswordVerifyOtp(payload: any) {
    //     return this.apiRequest.postdata(payload, config.auth.forgetPasswordVerifyOtp);
    // }

    loginWithOtp(payload: any) {
        return this.apiRequest.postdata(payload, config.auth.loginWithOtp);
    }

    logout() {
        this._NgbModal.dismissAll('logout');
        this.toater.cleanupDynamicComponent();

        this._WalletStore.reset();
        this._DashboardService.resetSideBar();
        sessionStorage.clear();
        this._UserService.resetLoginData();
        this._PermissionService.resetPermission();
        AppData.banners.next(null);
        // AppData.sidebarData.next(null);
        AppData.dashboardSubMenu.next(null);
        AppData.permissionsData.next(null);
        AppData.goToDashboard.next(false);

        this.route.navigate(['/login']);
    }
}
